import { Map, fromJS } from "immutable";
import { createSelector } from "reselect";

export const getFields = (state) => state.fields.get("fieldMap", Map());
export const getEmailFieldId = (state) => state.fields.get("emailFieldId", "");
export const getFieldConnectionStatusFilter = (state) => state.fields.get("fieldConnectionStatusFilter");

export const getPrimaryFields = createSelector([getFields], (fields) => {
	// this gets primary fields for a user (manager, group, job title)

	const capturedFieldIds = [];
	const primaryFieldNames = ["Manager", "Group", "Job Title"];

	primaryFieldNames.forEach((fieldName) => {
		fields.find((value) => {
			if (value.get("name") === fieldName) {
				capturedFieldIds.push({
					_id: value.get("_id"),
					name: fieldName,
					type: value.get("type"),
				});
			}

			return null;
		});
	});

	return fromJS(capturedFieldIds);
});

export const getJobTitleField = createSelector([getPrimaryFields], (primaryFields) => {
	const jobTitle = primaryFields.find((field) => field.get("name") === "Job Title");
	return jobTitle || null;
});
